/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ItemType } from './';
import {
    ItemTypeFromJSON,
    ItemTypeFromJSONTyped,
    ItemTypeToJSON,
} from './';
import type { PortfolioItem } from './';
import {
    PortfolioItemFromJSON,
    PortfolioItemFromJSONTyped,
    PortfolioItemToJSON,
} from './';
import type { ResponsivePicture } from './';
import {
    ResponsivePictureFromJSON,
    ResponsivePictureFromJSONTyped,
    ResponsivePictureToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioVideo
 */
export interface PortfolioVideo extends PortfolioItem {
    /**
     * 
     * @type {string}
     * @memberof PortfolioVideo
     */
    videoUrl?: string;
    /**
     * 
     * @type {ResponsivePicture}
     * @memberof PortfolioVideo
     */
    thumbnailUrl?: ResponsivePicture;
}

/**
 * Check if a given object implements the PortfolioVideo interface.
 */
export function instanceOfPortfolioVideo(value: object): value is PortfolioVideo {
    return true;
}

export function PortfolioVideoFromJSON(json: any): PortfolioVideo {
    return PortfolioVideoFromJSONTyped(json, false);
}

export function PortfolioVideoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioVideo {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...PortfolioItemFromJSONTyped(json, ignoreDiscriminator),
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : ResponsivePictureFromJSON(json['thumbnailUrl']),
    };
}

export function PortfolioVideoToJSON(value?: PortfolioVideo | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...PortfolioItemToJSON(value, true),
        'videoUrl': value['videoUrl'],
        'thumbnailUrl': ResponsivePictureToJSON(value['thumbnailUrl']),
    };
}

